import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface GalleryImage {
  id: number;
  title: string;
  imageUrl: string;
  sortOrder: number;
}

export interface GalleryRequest {
  title: string;
  imageUrl: string;
  sortOrder: number;
}

@Injectable({
  providedIn: 'root'
})
export class GalleryService {

  private api =
    'https://lazzaro-api1.onrender.com/api/gallery';

  private cloudinaryUrl =
    'https://api.cloudinary.com/v1_1/dle6ao4m7/image/upload';

  constructor(
    private http: HttpClient
  ) { }

  getImages(): Observable<GalleryImage[]> {

    return this.http.get<GalleryImage[]>(this.api);

  }

  createImage(image: GalleryRequest): Observable<GalleryImage> {

    return this.http.post<GalleryImage>(
      this.api,
      image,
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

  }

  updateImage(
    id: number,
    image: GalleryRequest
  ): Observable<void> {

    return this.http.put<void>(
      `${this.api}/${id}`,
      image,
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    );

  }

  deleteImage(id: number): Observable<void> {

    return this.http.delete<void>(
      `${this.api}/${id}`
    );

  }

  uploadImage(file: File): Observable<any> {

    const formData = new FormData();

    formData.append(
      'file',
      file
    );

    formData.append(
      'upload_preset',
      'lazzaro_unsigned'
    );

    return this.http.post(
      this.cloudinaryUrl,
      formData
    );

  }

}